export default "__VITE_ASSET__19wWIxZI__"